// List created on 03/12/2025

const instoreOrderPresetComments = [
  "0126JAN",
  "0226FEB",
  "0226LUNAR",
  "0326EASTER",
  "0326MAR",
  "0326FATHER",
  "0326RAMADAN",
  "0426APR",
  "0426EARTH",
  "0526MAY",
  "0626JUN",
  "0726JUL",
  "0826AUG",
  "0926SEP",
];

export default instoreOrderPresetComments;
